/**!
 * Created by Leonardo Cheslacki on 05/06/2024.
 *
 * MIT License
 *
 * Copyright (c) 2024 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import PropTypes from 'prop-types';

import PageController from './PageController';

import {HelpersIcon} from './../helpers';

import indexConfig from './../../../../config/index.config';

import pageConfig from './../../../../config/page.config';

import mainConfig from './../../../../config/main.config';

import WithType from './../WithType';

/**
 * REVIEW helpersIcon in all fla for color.
 */
class PageCurrent extends PageController {
    /**
     *
     * @param props
     * @param main
     */
    constructor(props, main) {
        super(props);

        this.props = props;
        this.main = main;

        this.state = {};

        this.$helpersIcon = HelpersIcon(this)({current_name: 'page'});

        PageCurrent._this = this;
    };

    $functions = {
        /**
         *
         * @param event
         */
        handle: function (event) {

        }
    };

    /**
     *
     * @returns {{paginates: (string|*), paginate: *, defaultPaginate: *}}
     */
    getPaginate = () => {
        const
            paginates = this.verifyField(this.getCurrentIndex(), 'paginates'),
            defaultPaginate = this.getDefaultIndex(paginates),
            paginate = this.getCurrentIndex(paginates) || defaultPaginate;

        return {defaultPaginate, paginate, paginates};
    };

    /**
     * Not usage direct.
     * @param execute
     */
    defaultInit = (execute = null) => {
        const
            {current_name, frame, color_icon} = this.props,
            _this_current = this.get();

        AllTap.$current_name = current_name;

        this.gotoAndStopFrame(_this_current, frame);

        this.pageIn();

        AllTap.emit('dynamic_frame', {frame: frame});

        this.$helpersIcon.setIcon(_this_current, color_icon);

        this.$helpersIcon.setIcon(this.getFrame(), color_icon);

        (typeof (execute) === 'function') && execute();

        /**
         * Preloader
         */
        AllTap.emit('process_end', {}, current_name);
    };

    /**
     * Not usage direct.
     * @param execute
     * @param dynamic
     * @param current_page
     */
    defaultPaginateInit = (execute = null, dynamic = null, current_page = null) => {
        const
            {current_name, frame, color_icon} = this.props,
            stagePaginate = AllTap.$stagePaginate({current_name: current_name, current_page: current_page}),
            _this_current = this.get();

        AllTap.$current_name = current_name;

        this.gotoAndStopFrame(_this_current, frame);

        this.pageIn();

        stagePaginate.mainPaginate(dynamic);

        this.$helpersIcon.setIcon(_this_current, color_icon);

        this.$helpersIcon.setIcon(this.getFrame(), color_icon);

        (typeof (execute) === 'function') && execute(stagePaginate);

        /**
         * Preloader
         */
        AllTap.emit('process_end', {}, current_name);
    };

    /**
     * Single page.
     * Included helpersIcon color.
     */
    initCover = this.defaultInit;

    /**
     * Single page.
     * Included helpersIcon color.
     * For all pages simple.
     */
    initRecord = this.defaultInit;

    /**
     * Paginate.
     * Included helpersIcon color.
     * For all pages simple.
     */
    initPaginate = this.defaultPaginateInit;

    initVacancies = () => {
        // this.defaultInit((stagePaginate) => {
        this.defaultPaginateInit((stagePaginate) => {
            const _this_frame = this.getFrame();

            const {current_name} = this.props;

            const layerPin = AllTap.$layerPin({current_name: current_name});
            layerPin.mainPin();

            _this_frame.ap51.name = "ap51";
            _this_frame.ap52.name = "ap52";
            _this_frame.ap53.name = "ap53";
            _this_frame.ap54.name = "ap54";
            _this_frame.ap55.name = "ap55";
            _this_frame.ap56.name = "ap56";

            _this_frame.ap61.name = "ap61";
            _this_frame.ap62.name = "ap62";
            _this_frame.ap63.name = "ap63";
            _this_frame.ap64.name = "ap64";
            _this_frame.ap65.name = "ap65";
            _this_frame.ap66.name = "ap66";

            _this_frame.ap71.name = "ap71";
            _this_frame.ap72.name = "ap72";
            _this_frame.ap73.name = "ap73";
            _this_frame.ap74.name = "ap74";
            _this_frame.ap75.name = "ap75";
            _this_frame.ap76.name = "ap76";

            _this_frame.ap81.name = "ap81";
            _this_frame.ap82.name = "ap82";
            _this_frame.ap83.name = "ap83";
            _this_frame.ap84.name = "ap84";
            _this_frame.ap85.name = "ap85";
            _this_frame.ap86.name = "ap86";

            _this_frame.ap91.name = "ap91";
            _this_frame.ap92.name = "ap92";
            _this_frame.ap93.name = "ap93";
            _this_frame.ap94.name = "ap94";
            _this_frame.ap95.name = "ap95";
            _this_frame.ap96.name = "ap96";

            _this_frame.ap101.name = "ap101";
            _this_frame.ap102.name = "ap102";
            _this_frame.ap103.name = "ap103";
            _this_frame.ap104.name = "ap104";
            _this_frame.ap105.name = "ap105";
            _this_frame.ap106.name = "ap106";

            _this_frame.ap111.name = "ap111";
            _this_frame.ap112.name = "ap112";
            _this_frame.ap113.name = "ap113";
            _this_frame.ap114.name = "ap114";
            _this_frame.ap115.name = "ap115";
            _this_frame.ap116.name = "ap116";

            _this_frame.ap121.name = "ap121";
            _this_frame.ap122.name = "ap122";
            _this_frame.ap123.name = "ap123";
            _this_frame.ap124.name = "ap124";
            _this_frame.ap125.name = "ap125";
            _this_frame.ap126.name = "ap126";

            _this_frame.ap131.name = "ap131";
            _this_frame.ap132.name = "ap132";
            _this_frame.ap133.name = "ap133";
            _this_frame.ap134.name = "ap134";
            _this_frame.ap135.name = "ap135";
            _this_frame.ap136.name = "ap136";

            _this_frame.ap141.name = "ap141";
            _this_frame.ap142.name = "ap142";
            _this_frame.ap143.name = "ap143";
            _this_frame.ap144.name = "ap144";
            _this_frame.ap145.name = "ap145";
            _this_frame.ap146.name = "ap146";

            _this_frame.ap151.name = "ap151";
            _this_frame.ap152.name = "ap152";
            _this_frame.ap153.name = "ap153";
            _this_frame.ap154.name = "ap154";
            _this_frame.ap155.name = "ap155";
            _this_frame.ap156.name = "ap156";

            _this_frame.ap161.name = "ap161";
            _this_frame.ap162.name = "ap162";
            _this_frame.ap163.name = "ap163";
            _this_frame.ap164.name = "ap164";
            _this_frame.ap165.name = "ap165";
            _this_frame.ap166.name = "ap166";

            _this_frame.ap171.name = "ap171";
            _this_frame.ap172.name = "ap172";
            _this_frame.ap173.name = "ap173";
            _this_frame.ap174.name = "ap174";
            _this_frame.ap175.name = "ap175";
            _this_frame.ap176.name = "ap176";

            _this_frame.ap181.name = "ap181";
            _this_frame.ap182.name = "ap182";
            _this_frame.ap183.name = "ap183";
            _this_frame.ap184.name = "ap184";
            _this_frame.ap185.name = "ap185";
            _this_frame.ap186.name = "ap186";

            _this_frame.ap191.name = "ap191";
            _this_frame.ap192.name = "ap192";
            _this_frame.ap193.name = "ap193";
            _this_frame.ap194.name = "ap194";
            _this_frame.ap195.name = "ap195";
            _this_frame.ap196.name = "ap196";

            _this_frame.ap201.name = "ap201";
            _this_frame.ap202.name = "ap202";
            _this_frame.ap203.name = "ap203";
            _this_frame.ap204.name = "ap204";
            _this_frame.ap205.name = "ap205";
            _this_frame.ap206.name = "ap206";

            _this_frame.ap211.name = "ap211";
            _this_frame.ap212.name = "ap212";
            _this_frame.ap213.name = "ap213";
            _this_frame.ap214.name = "ap214";
            _this_frame.ap215.name = "ap215";
            _this_frame.ap216.name = "ap216";

            _this_frame.ap221.name = "ap221";
            _this_frame.ap222.name = "ap222";
            _this_frame.ap223.name = "ap223";
            _this_frame.ap224.name = "ap224";
            _this_frame.ap225.name = "ap225";
            _this_frame.ap226.name = "ap226";

            _this_frame.ap231.name = "ap231";
            _this_frame.ap232.name = "ap232";
            _this_frame.ap233.name = "ap233";
            _this_frame.ap234.name = "ap234";
            _this_frame.ap235.name = "ap235";
            _this_frame.ap236.name = "ap236";

            _this_frame.ap241.name = "ap241";
            _this_frame.ap242.name = "ap242";
            _this_frame.ap243.name = "ap243";
            _this_frame.ap244.name = "ap244";
            _this_frame.ap245.name = "ap245";
            _this_frame.ap246.name = "ap246";

            _this_frame.ap251.name = "ap251";
            _this_frame.ap252.name = "ap252";
            _this_frame.ap253.name = "ap253";
            _this_frame.ap254.name = "ap254";
            _this_frame.ap255.name = "ap255";
            _this_frame.ap256.name = "ap256";

            _this_frame.ap261.name = "ap261";
            _this_frame.ap262.name = "ap262";
            _this_frame.ap263.name = "ap263";
            _this_frame.ap264.name = "ap264";
            _this_frame.ap265.name = "ap265";
            _this_frame.ap266.name = "ap266";

            _this_frame.ap271.name = "ap271";
            _this_frame.ap272.name = "ap272";
            _this_frame.ap273.name = "ap273";
            _this_frame.ap274.name = "ap274";
            _this_frame.ap275.name = "ap275";
            _this_frame.ap276.name = "ap276";

            _this_frame.ap281.name = "ap281";
            _this_frame.ap282.name = "ap282";
            _this_frame.ap283.name = "ap283";
            _this_frame.ap284.name = "ap284";
            _this_frame.ap285.name = "ap285";
            _this_frame.ap286.name = "ap286";

            _this_frame.ap291.name = "ap291";
            _this_frame.ap292.name = "ap292";
            _this_frame.ap293.name = "ap293";
            _this_frame.ap294.name = "ap294";
            _this_frame.ap295.name = "ap295";
            _this_frame.ap296.name = "ap296";

            _this_frame.ap301.name = "ap301";
            _this_frame.ap302.name = "ap302";
            _this_frame.ap303.name = "ap303";
            _this_frame.ap304.name = "ap304";
            _this_frame.ap305.name = "ap305";
            _this_frame.ap306.name = "ap306";

            _this_frame.ap311.name = "ap311";
            _this_frame.ap312.name = "ap312";
            _this_frame.ap313.name = "ap313";
            _this_frame.ap314.name = "ap314";
            _this_frame.ap315.name = "ap315";
            _this_frame.ap316.name = "ap316";

            _this_frame.ap321.name = "ap321";
            _this_frame.ap322.name = "ap322";
            _this_frame.ap323.name = "ap323";
            _this_frame.ap324.name = "ap324";
            _this_frame.ap325.name = "ap325";
            _this_frame.ap326.name = "ap326";

            _this_frame.ap331.name = "ap331";
            _this_frame.ap332.name = "ap332";
            _this_frame.ap333.name = "ap333";
            _this_frame.ap334.name = "ap334";
            _this_frame.ap335.name = "ap335";
            _this_frame.ap336.name = "ap336";

            _this_frame.ap341.name = "ap341";
            _this_frame.ap342.name = "ap342";
            _this_frame.ap343.name = "ap343";
            _this_frame.ap344.name = "ap344";
            _this_frame.ap345.name = "ap345";
            _this_frame.ap346.name = "ap346";

            _this_frame.ap351.name = "ap351";
            _this_frame.ap352.name = "ap352";
            _this_frame.ap353.name = "ap353";
            _this_frame.ap354.name = "ap354";
            _this_frame.ap355.name = "ap355";
            _this_frame.ap356.name = "ap356";

            _this_frame.ap361.name = "ap361";
            _this_frame.ap362.name = "ap362";


            _this_frame.ap51.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap52.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap53.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap54.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap55.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap56.addEventListener("click", test.bind(_this_frame));

            _this_frame.ap61.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap62.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap63.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap64.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap65.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap66.addEventListener("click", test.bind(_this_frame));

            _this_frame.ap71.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap72.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap73.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap74.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap75.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap76.addEventListener("click", test.bind(_this_frame));

            _this_frame.ap81.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap82.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap83.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap84.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap85.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap86.addEventListener("click", test.bind(_this_frame));

            _this_frame.ap91.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap92.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap93.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap94.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap95.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap96.addEventListener("click", test.bind(_this_frame));

            _this_frame.ap101.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap102.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap103.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap104.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap105.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap106.addEventListener("click", test.bind(_this_frame));

            _this_frame.ap111.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap112.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap113.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap114.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap115.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap116.addEventListener("click", test.bind(_this_frame));

            _this_frame.ap121.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap122.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap123.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap124.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap125.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap126.addEventListener("click", test.bind(_this_frame));

            _this_frame.ap131.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap132.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap133.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap134.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap135.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap136.addEventListener("click", test.bind(_this_frame));

            _this_frame.ap141.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap142.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap143.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap144.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap145.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap146.addEventListener("click", test.bind(_this_frame));

            _this_frame.ap151.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap152.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap153.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap154.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap155.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap156.addEventListener("click", test.bind(_this_frame));

            _this_frame.ap161.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap162.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap163.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap164.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap165.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap166.addEventListener("click", test.bind(_this_frame));

            _this_frame.ap171.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap172.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap173.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap174.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap175.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap176.addEventListener("click", test.bind(_this_frame));

            _this_frame.ap181.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap182.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap183.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap184.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap185.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap186.addEventListener("click", test.bind(_this_frame));


            _this_frame.ap191.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap192.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap193.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap194.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap195.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap196.addEventListener("click", test.bind(_this_frame));


            _this_frame.ap201.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap202.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap203.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap204.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap205.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap206.addEventListener("click", test.bind(_this_frame));

            _this_frame.ap211.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap212.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap213.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap214.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap215.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap216.addEventListener("click", test.bind(_this_frame));

            _this_frame.ap221.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap222.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap223.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap224.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap225.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap226.addEventListener("click", test.bind(_this_frame));

            _this_frame.ap231.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap232.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap233.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap234.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap235.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap236.addEventListener("click", test.bind(_this_frame));

            _this_frame.ap241.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap242.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap243.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap244.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap245.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap246.addEventListener("click", test.bind(_this_frame));

            _this_frame.ap251.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap252.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap253.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap254.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap255.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap256.addEventListener("click", test.bind(_this_frame));

            _this_frame.ap261.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap262.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap263.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap264.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap265.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap266.addEventListener("click", test.bind(_this_frame));

            _this_frame.ap271.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap272.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap273.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap274.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap275.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap276.addEventListener("click", test.bind(_this_frame));

            _this_frame.ap281.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap282.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap283.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap284.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap285.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap286.addEventListener("click", test.bind(_this_frame));

            _this_frame.ap291.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap292.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap293.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap294.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap295.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap296.addEventListener("click", test.bind(_this_frame));

            _this_frame.ap301.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap302.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap303.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap304.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap305.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap306.addEventListener("click", test.bind(_this_frame));

            _this_frame.ap311.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap312.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap313.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap314.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap315.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap316.addEventListener("click", test.bind(_this_frame));

            _this_frame.ap321.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap322.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap323.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap324.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap325.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap326.addEventListener("click", test.bind(_this_frame));

            _this_frame.ap331.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap332.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap333.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap334.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap335.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap336.addEventListener("click", test.bind(_this_frame));

            _this_frame.ap341.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap342.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap343.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap344.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap345.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap346.addEventListener("click", test.bind(_this_frame));

            _this_frame.ap351.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap352.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap353.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap354.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap355.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap356.addEventListener("click", test.bind(_this_frame));

            _this_frame.ap361.addEventListener("click", test.bind(_this_frame));
            _this_frame.ap362.addEventListener("click", test.bind(_this_frame));

            function test(evt) {
                var botao = evt.currentTarget;
                var container = botao.parent;

                for (var i = 0; i < container.numChildren; i++) {
                    var obj = container.getChildAt(i);
                    if (PageCurrent._this.hasString(obj.name, 'ap')) {
                        obj.gotoAndStop(0);
                        _this_frame.marcacoes.gotoAndStop(evt.target.parent.name);
                    }
                }

                botao.gotoAndStop(1);
            }
        }, 2);
    };

    initMenu = () => {
        const {btn_menu01, btn_menu02} = AllTap.getState('_this_menu');

        this.setHandleMouseDown(btn_menu01, () => {
            this.pageOut();
            AllTap.$current_name_sub = 'planta01';
            AllTap.$current_frame_sub = 1;
        });

        this.setHandleMouseDown(btn_menu02, () => {
            this.pageOut();
            AllTap.$current_name_sub = 'planta02';
            AllTap.$current_frame_sub = 2;
        });

        /**
         * Preloader
         */
        AllTap.emit('process_end', {}, this.props.current_name);
    };

    initPortal = () => {
        this.defaultInit(() => {
            const {btn_01, btn_02} = this.getFrame();

            this.setHandleMouseDown(btn_01, () => {
                window.open('http://reserva-web.local', '_self');
            });

            this.setHandleMouseDown(btn_02, () => {
                window.open('http://reserva-bosque-web.local', '_self');
            });
        });
    };

    /**
     * Single page.
     * Included stageGallery and helpersIcon color.
     */
    initGallery = () => {
        this.defaultInit(() => {
            AllTap.$stageGallery({
                current_name: this.props.current_name,
                xml: this.verifyField(this.getCurrentIndex(), 'xml')
            }).mainGallery();
        });
    };

    /**
     * Paginate.
     * Included stageGallery and helpersIcon color.
     * @param current_page
     */
    initGalleryPaginate = (current_page) => {
        this.defaultPaginateInit(() => {
            const
                {current_name} = this.props,
                {defaultPaginate, paginate} = this.getPaginate();

            if (this.inArray([2, 3], paginate.frame)) {
                AllTap.$stageGallery({
                    current_name: current_name,
                    xml: this.verifyField(this.getCurrentIndex(), 'xml')
                }).mainGallery();

                const anim_container = document.getElementById('animation_container');

                AllTap.$element_img = document.createElement('IMG');

                this.setAttributes(AllTap.$element_img, {
                    id: 'close_overlay_container',
                    alt: 'close',
                    src: this.getUriImage('close.png'),
                    width: this.calcSize(1, stage.scaleX, 40, false, 'int'),
                    height: this.calcSize(1, stage.scaleY, 40, false, 'int')
                });

                const close = () => {
                    this.removeListener('click', 'click-close-overlay-container');

                    this.pageOut();

                    AllTap.$current_name_sub = this.verifyField(defaultPaginate, 'name');
                    AllTap.$current_frame_sub = this.verifyField(defaultPaginate, 'frame');
                    AllTap.$element_img.remove();
                };

                this.removeListener('click', 'click-close-overlay-container', () => {
                    this.addListener(AllTap.$element_img, 'click', 'click-close-overlay-container', close);
                });

                anim_container.appendChild(AllTap.$element_img);
            }
        });
    };

    /**
     * Single page.
     * Included stagePin and helpersIcon color.
     */
    initImplantation = () => {
        this.defaultInit(() => {
            const paginate = this.getCurrentIndex();
            AllTap.$stagePin({
                current_name: this.props.current_name,
                xml: this.verifyField(paginate, 'xml'),
                content_text: this.verifyField(paginate, 'content_text')
            }).mainPin();
        });
    };

    /**
     * Paginate.
     * Included helpersIcon color.
     */
    initImplantationPaginate = () => {
        this.defaultPaginateInit(() => {
            const
                _this_current = this.get(),
                {current_name, color_icon} = this.props,
                {paginate, paginates} = this.getPaginate();

            AllTap.$stagePin({
                current_name: current_name,
                xml: this.verifyField(paginate, 'xml'),
                content_text: this.verifyField(paginate, 'content_text'),
                extra: this.verifyField(paginate, 'extra')
            }).mainPin();

            for (let property of paginates) {
                this.$helpersIcon.setIcon(_this_current, color_icon, property.frame);
            }

            this.$helpersIcon.disabledAnimate(_this_current)(paginate.frame);
        });
    };

    /**
     * Paginate.
     * Included helpersIcon color.
     */
    initDifferentialPaginate = () => {
        this.defaultPaginateInit(() => {
            const
                _this_current = this.get(),
                {color_icon} = this.props,
                {paginate, paginates} = this.getPaginate();

            for (let property of paginates) {
                this.$helpersIcon.setIcon(_this_current, color_icon, property.frame);
            }

            this.$helpersIcon.disabledAnimate(_this_current)(paginate.frame);
        });
    };

    /**
     * Paginate.
     * Included stagePaginate, layerDifferential, layerCamera, layerPin and helpersIcon color.
     */
    initPlantPaginate = () => {
        this.defaultPaginateInit((stagePaginate) => {
            const
                _this_current = this.get(),
                {current_name, color_icon} = this.props,
                {paginate, paginates} = this.getPaginate();

            // if (paginate.frame === 2) {
            //     AllTap.$stageGallery({
            //         current_name: current_name,
            //         xml: this.verifyField(paginate, 'xml')
            //     }).mainGallery();
            // }

            if (paginate.frame === 1) {
                const {btn_tour} = _this_current;

                const execute = (event, options) => {
                    let occ_button = this.getObject(options, 'occ_button');
                    this.openTour(occ_button, options);
                };

                this.setHandleMouseDown(btn_tour, execute, {
                    occ_button: btn_tour,
                    name: 'video-01',
                    uri: 'https://tour.meupasseiovirtual.com/view/VjeeRIvsoSx'
                });
            }

            if (this.verifyField(paginate, 'active.differential')) {
                const layerDifferential = AllTap.$layerDifferential({
                    current_name: current_name,
                    enabled: this.verifyField(paginate, 'active.differential_enabled')
                });
                layerDifferential.mainDifferential();
                stagePaginate.setState({...stagePaginate.state, differential: layerDifferential});
            }

            if (this.verifyField(paginate, 'active.camera')) {
                const layerCamera = AllTap.$layerCamera({current_name: current_name});
                layerCamera.mainCamera();
                stagePaginate.setState({...stagePaginate.state, camera: layerCamera});
            }

            if (this.verifyField(paginate, 'active.pin')) {
                const layerPin = AllTap.$layerPin({current_name: current_name});
                layerPin.mainPin();
                stagePaginate.setState({...stagePaginate.state, pin: layerPin});
            }

            for (let property of paginates) {
                this.$helpersIcon.setIcon(_this_current, color_icon, property.frame);
            }

            this.$helpersIcon.disabledAnimate(_this_current)(paginate.frame);
        });
    };

    initLocalizationDynamic = () => {
        this.defaultPaginateInit(() => {
            this.main.on('dynamic_paginate', ({number_current, current_name}) => {
                const
                    _this_frame = this.getFrame(),
                    {occ_convenience, occ_pseudo} = _this_frame;

                if (current_name === this.props.current_name) {
                    if (number_current === 2) {
                        occ_convenience.gotoAndStop('empty');
                        occ_pseudo.gotoAndStop('empty');
                        occ_convenience.btn_close.visible = false;

                        this.setHandleMouseDown(occ_convenience.btn_close, () => {
                            this.effectFadeOut(_this_frame, 'occ_convenience', () => {
                                occ_convenience.gotoAndStop('empty');
                                occ_pseudo.gotoAndStop('empty');
                                occ_convenience.btn_close.visible = false;
                            });
                        });

                        for (let i = 1; i < 8; i++) {
                            let occ = _this_frame[`btn_${this.padWithLeadingZeros(i, 2)}`];
                            this.setHandleMouseDown(occ, () => {
                                this.effectFadeIn(_this_frame, 'occ_convenience');
                                this.gotoAndStopFrame(occ_convenience, i);
                                this.gotoAndStopFrame(occ_pseudo, i);
                                occ_convenience.btn_close.visible = true;
                            });
                        }
                    }
                }
            }, this.props.current_name);
        }, true);
    };

    initLocalizationPaginate = () => {
        this.defaultPaginateInit(() => {
            const
                _this_current = this.get(),
                {current_name} = this.props,
                {paginate} = this.getPaginate();

            if (paginate.frame === 1) {
                AllTap.$stageLocalization({
                    current_name: current_name,
                    xml: this.verifyField(paginate, 'xml')
                }).mainLocalization();
            } else if (paginate.frame === 2) {
                const
                    buttons = this.verifyField(_this_current, 'occ_frame_01.occ_marker.occ_buttons.children'),
                    markers = this.verifyField(_this_current, 'occ_frame_01.occ_marker.occ_markers');

                let current_btn, current_marker;

                const showMarker = function (event) {
                    const {button, marker} = this;

                    if (current_btn === button) {
                        current_btn.gotoAndPlay('off');
                        current_marker.gotoAndPlay('off');
                        current_btn = '';
                        current_marker = '';

                        return;
                    } else if (current_btn) {
                        current_btn.gotoAndPlay('off');
                        current_marker.gotoAndPlay('off');
                    }

                    current_btn = button;
                    current_marker = marker;
                    button.gotoAndPlay('on');
                    marker.gotoAndPlay('on');
                }

                buttons.forEach((button) => {
                    const
                        btn_number = parseInt(button.name.split('_')[1]),
                        number = (btn_number < 10) ? `0${btn_number}` : btn_number,
                        marker = markers[`occ_marker_${number}`];

                    button.gotoAndPlay('off');
                    marker.gotoAndPlay('off');
                    button.btn.removeEventListener('click', showMarker);
                    button.btn.addEventListener('click', showMarker.bind({button, marker}));
                });
            } else if (paginate.frame === 3) {
                AllTap.$stageSlider({current_name: current_name, composition_name: paginate.name}).mainSlider();
            }
        });
    };

    initConveniencePaginate = () => {
        this.defaultPaginateInit(() => {
            const
                {btn_video} = this.get(),
                {current_name, current_page} = this.props;

            AllTap.$stageSlider({current_name, current_page}).mainSlider();

            const execute = (event, options) => {
                let occ_button = this.verifyField(options, 'occ_button');
                this.openVideo(occ_button, options);
            };

            this.setHandleMouseDown(btn_video, execute, {
                occ_button: btn_video,
                name: 'video',
                uri: 'example.mp4'
            });
        }, 1);
    };

    initPanoramicPaginate = () => {
        this.defaultPaginateInit(() => {
            const {btn_video} = this.get();

            const execute = (event, options) => {
                let occ_button = this.verifyField(options, 'occ_button');
                this.openVideo(occ_button, options);
            };

            this.setHandleMouseDown(btn_video, execute, {
                occ_button: btn_video,
                name: 'video',
                uri: 'example.mp4'
            });
        }, 2);
    };

    initMapPaginate = () => {
        this.defaultPaginateInit(() => {
            const {btn_video} = this.get();

            const execute = (event, options) => {
                let occ_button = this.verifyField(options, 'occ_button');
                this.openVideo(occ_button, options);
            };

            this.setHandleMouseDown(btn_video, execute, {
                occ_button: btn_video,
                name: 'video',
                uri: 'example.mp4'
            });
        }, 3);
    };

    initMap = () => {
        this.defaultPaginateInit(() => {
            const
                {show_map_tool} = mainConfig.map,
                current_name = this.props.current_name;

            AllTap.$stageMapSelector({current_name}).initMapSelector();

            if (show_map_tool) { // Set show_map_tool=true in order to render map helper tool (for development only).
                AllTap.$stageMapTool({current_name}).makeTest();
            }
        });
    };

    initVideoPaginate = () => {
        this.defaultPaginateInit(() => {
            const {btn_video} = this.get();

            const execute = (event, options) => {
                let occ_button = this.verifyField(options, 'occ_button');
                this.openVideo(occ_button, options);
            };

            this.setHandleMouseDown(btn_video, execute, {
                occ_button: btn_video,
                name: 'video',
                uri: 'example.mp4'
            });
        });
    };

    /**
     * REVIEW
     * Single page.
     * Included helpersIcon color.
     */
    initProject = () => {
        this.defaultInit(() => {
            const
                {occ_project: {occ_project_01, occ_project_02, occ_project_03}} = this.getFrame(),
                {color_icon} = this.props;

            this.setHandleMouseDown(occ_project_01.btn_more, () => {
                (occ_project_02.currentLabel === 'complete') && occ_project_02.gotoAndPlay('complete');
                (occ_project_03.currentLabel === 'complete') && occ_project_03.gotoAndPlay('complete');

                occ_project_01.gotoAndPlay('start');
            }, null, `${occ_project_01.name}_more`);

            this.setHandleMouseDown(occ_project_01.btn_less, () => {
                occ_project_01.gotoAndPlay('complete');
            }, null, `${occ_project_01.name}_less`);

            this.$helpersIcon.setIcon(occ_project_01, color_icon);
            this.$helpersIcon.setIcon(occ_project_01.btn_more, color_icon);

            this.setHandleMouseDown(occ_project_02.btn_more, () => {
                (occ_project_01.currentLabel === 'complete') && occ_project_01.gotoAndPlay('complete');
                (occ_project_03.currentLabel === 'complete') && occ_project_03.gotoAndPlay('complete');

                occ_project_02.gotoAndPlay('start');
            }, null, `${occ_project_02.name}_more`);

            this.setHandleMouseDown(occ_project_02.btn_less, () => {
                occ_project_02.gotoAndPlay('complete');
            }, null, `${occ_project_02.name}_less`);

            this.$helpersIcon.setIcon(occ_project_02, color_icon);
            this.$helpersIcon.setIcon(occ_project_02.btn_more, color_icon);

            this.setHandleMouseDown(occ_project_03.btn_more, () => {
                (occ_project_01.currentLabel === 'complete') && occ_project_01.gotoAndPlay('complete');
                (occ_project_02.currentLabel === 'complete') && occ_project_02.gotoAndPlay('complete');

                occ_project_03.gotoAndPlay('start');
            }, null, `${occ_project_03.name}_more`);

            this.setHandleMouseDown(occ_project_03.btn_less, () => {
                occ_project_03.gotoAndPlay('complete');
            }, null, `${occ_project_03.name}_less`);

            this.$helpersIcon.setIcon(occ_project_03, color_icon);
            this.$helpersIcon.setIcon(occ_project_03.btn_more, color_icon);
        });
    };

    initProjectPaginate = () => {
        this.defaultPaginateInit(() => {
            const
                {occ_project: {occ_project_01, occ_project_02, occ_project_03}} = this.getFrame(),
                {color_icon} = this.props;

            this.setHandleMouseDown(occ_project_01.btn_more, () => {
                (occ_project_02.currentLabel === 'complete') && occ_project_02.gotoAndPlay('complete');
                (occ_project_03.currentLabel === 'complete') && occ_project_03.gotoAndPlay('complete');

                occ_project_01.gotoAndPlay('start');
            }, null, `${occ_project_01.name}_more`);

            this.setHandleMouseDown(occ_project_01.btn_less, () => {
                occ_project_01.gotoAndPlay('complete');
            }, null, `${occ_project_01.name}_less`);

            this.$helpersIcon.setIcon(occ_project_01, color_icon);
            this.$helpersIcon.setIcon(occ_project_01.btn_more, color_icon);

            this.setHandleMouseDown(occ_project_02.btn_more, () => {
                (occ_project_01.currentLabel === 'complete') && occ_project_01.gotoAndPlay('complete');
                (occ_project_03.currentLabel === 'complete') && occ_project_03.gotoAndPlay('complete');

                occ_project_02.gotoAndPlay('start');
            }, null, `${occ_project_02.name}_more`);

            this.setHandleMouseDown(occ_project_02.btn_less, () => {
                occ_project_02.gotoAndPlay('complete');
            }, null, `${occ_project_02.name}_less`);

            this.$helpersIcon.setIcon(occ_project_02, color_icon);
            this.$helpersIcon.setIcon(occ_project_02.btn_more, color_icon);

            this.setHandleMouseDown(occ_project_03.btn_more, () => {
                (occ_project_01.currentLabel === 'complete') && occ_project_01.gotoAndPlay('complete');
                (occ_project_02.currentLabel === 'complete') && occ_project_02.gotoAndPlay('complete');

                occ_project_03.gotoAndPlay('start');
            }, null, `${occ_project_03.name}_more`);

            this.setHandleMouseDown(occ_project_03.btn_less, () => {
                occ_project_03.gotoAndPlay('complete');
            }, null, `${occ_project_03.name}_less`);

            this.$helpersIcon.setIcon(occ_project_03, color_icon);
            this.$helpersIcon.setIcon(occ_project_03.btn_more, color_icon);
        });
    };

    // initProjectPaginate = () => {
    //     this.defaultPaginateInit(() => {
    //         const
    //             _this_current = this.get(),
    //             _this_frame = this.getFrame(),
    //             {current_name, color_icon} = this.props,
    //             {paginate, paginates} = this.getPaginate();
    //
    //         if (paginate.frame === 1) {
    //             _this_frame.occ_sector.gotoAndPlay('sector01');
    //
    //             let children = this.verifyField(_this_frame, 'occ_button.children');
    //
    //             if (this.isArrayIf(children)) {
    //                 for (let property of children) {
    //                     this.setHandleMouseDown(property, () => {
    //                         _this_frame.occ_sector.gotoAndPlay(`sector${this.padWithLeadingZeros(this.toNumber(property.name), 2)}`);
    //                     });
    //                 }
    //             }
    //         } else if (this.inArray([2, 6], paginate.frame)) {
    //             AllTap.$stagePin({
    //                 current_name: current_name,
    //                 xml: this.verifyField(paginate, 'xml'),
    //                 content_text: this.verifyField(paginate, 'content_text')
    //             }).mainPin();
    //         } else if (this.inArray([3, 7, 8, 9], paginate.frame)) {
    //             for (let property of paginates) {
    //                 this.$helpersIcon.setIcon(_this_current, (paginate.frame === property.frame ? '0xFFFFFF' : color_icon), property.frame);
    //             }
    //
    //             this.$helpersIcon.disabledAnimate(_this_current)(paginate.frame);
    //         }
    //     });
    // };

    initOdometer = () => {
        this.defaultInit(() => {
            const {occ_effect_01: {occ_odometer_01, occ_odometer_02, occ_odometer_03}} = this.getFrame();

            let
                originalY01 = this.getStateOccurrence(occ_odometer_01, 'state.originalY'),
                originalY02 = this.getStateOccurrence(occ_odometer_02, 'state.originalY'),
                originalY03 = this.getStateOccurrence(occ_odometer_03, 'state.originalY');

            if (!originalY01) {
                originalY01 = occ_odometer_01.y;
                this.setStateOccurrence(occ_odometer_01, {originalY: originalY01});
            }

            if (!originalY02) {
                originalY02 = occ_odometer_02.y;
                this.setStateOccurrence(occ_odometer_02, {originalY: originalY02});
            }

            if (!originalY03) {
                originalY03 = occ_odometer_03.y;
                this.setStateOccurrence(occ_odometer_03, {originalY: originalY03});
            }

            occ_odometer_01.y = (originalY01 + 15);

            occ_odometer_02.y = (originalY02 + 15);

            occ_odometer_03.y = (originalY03 + 10);

            this.odometer(occ_odometer_01, 60, true, () => {
                this.odometer(occ_odometer_02, 6800, true, () => {
                    this.odometer(occ_odometer_03, 1500000, true);
                });
            });
        });
    };

    initRationalPaginate = () => {
        this.defaultPaginateInit();
        // this.defaultPaginateInit((stagePaginate) => {
        //     AllTap.on('dynamic_paginate', ({number_current, current_name}) => {
        //         if(current_name === this.props.current_name){
        //             if (number_current === 2) {
        //                 const _this_frame = this.getFrame();
        //
        //                 let children = this.verifyField(_this_frame, 'occ_card.occ_button.children');
        //
        //                 if (this.isArrayIf(children)) {
        //                     for (let property of children) {
        //                         this.setHandleMouseDown(property, () => {
        //                             _this_frame.occ_card.gotoAndStop(`card${this.padWithLeadingZeros(this.toNumber(property.name), 2)}`);
        //                         });
        //                     }
        //                 }
        //             }
        //         }
        //     }, this.props.current_name);
        // }, true);
    };

    initInstitutionalPaginate = () => {
        this.defaultPaginateInit(() => {

            const execute = (event, options) => {
                let occ_button = this.verifyField(options, 'occ_button');
                this.openVideo(occ_button, options);
            };

            AllTap.on('dynamic_paginate', ({number_current, current_name}) => {
                if (current_name === this.props.current_name) {
                    if (number_current === 2) {
                        AllTap.$stageSlider({
                            current_name: this.props.current_name,
                            composition_name: this.props.current_name
                        }).mainSlider();
                    } else if (number_current === 3) {
                        let {btn_video01} = this.getFrame();

                        this.setHandleMouseDown(btn_video01, execute, {
                            occ_button: btn_video01,
                            name: 'video-01',
                            uri: 'vr-girl.mp4'
                        });
                    }
                }
            }, this.props.current_name);

        }, true);
    };

    /**
     * Paginate.
     * Included stagePaginate, stageView and helpersIcon color.
     */
    initView = () => {
        this.defaultPaginateInit(() => {
            const {current_name} = this.props;
            AllTap.$stageView({
                current_name: current_name,
                xml: this.verifyField(this.getCurrentIndex(), 'xml'),
            }).initView();
        }, true);
    };

    /**
     * Single page.
     * Included stageSun and helpersIcon color.
     */
    initOrientation = () => {
        this.defaultInit(() => {
            const {current_name} = this.props;
            AllTap.$stageSun({current_name: current_name}).mainSun();
        });
    };

    /**
     * Paginate.
     * Included helpersIcon color.
     */
    initOrientationPaginate = () => {
        this.defaultPaginateInit(() => {
            const
                _this_current = this.get(),
                {current_name, current_page, color_icon} = this.props,
                {paginate, paginates} = this.getPaginate();

            AllTap.$stageSun({current_name, current_page}).mainSun();

            for (let property of paginates) {
                this.$helpersIcon.setIcon(_this_current, color_icon, property.frame);
            }

            this.$helpersIcon.disabledAnimate(_this_current)(paginate.frame);
        });
    };

    /**
     * Single page.
     * Included stageZoom and helpersIcon color.
     */
    initZoom = () => {
        this.defaultInit(() => {
            const {current_name} = this.props;
            AllTap.$stageZoom({current_name}).mainZoom();
        });
    };

    /**
     * Paginate.
     * Included stageZoom and helpersIcon color.
     */
    initZoomPaginate = () => {
        this.defaultPaginateInit(() => {
            const
                _this_current = this.get(),
                {current_name, current_page, color_icon} = this.props,
                {paginate, paginates} = this.getPaginate();

            AllTap.$stageZoom({current_name, current_page}).mainZoom();

            for (let property of paginates) {
                this.$helpersIcon.setIcon(_this_current, color_icon, property.frame);
            }

            this.$helpersIcon.disabledAnimate(_this_current)(paginate.frame);
        });
    };

    /**
     * Single page.
     * Included stageSlider and helpersIcon color.
     */
    initSlider = () => {
        this.defaultInit(() => {
            const {current_name} = this.props;
            AllTap.$stageSlider({current_name: current_name, composition_name: current_name}).mainSlider();
        });
    };

    /**
     * Single page.
     * Included stageScroll and helpersIcon color.
     */
    initScroll = () => {
        this.defaultInit(() => {
            AllTap.$stageScroll({current_name: this.props.current_name}).mainScroll();
        });
    };

    /**
     * Single page.
     * Included stageQuiz and helpersIcon color.
     */
    initQuiz = () => {
        this.defaultInit(() => {
            AllTap.$stageQuiz({current_name: this.props.current_name}).mainQuiz();
        });
    };

    /**
     * Single page.
     * Included stageMemory and helpersIcon color.
     */
    initMemory = () => {
        this.defaultInit(() => {
            AllTap.$stageMemory({current_name: this.props.current_name}).mainMemory();
        });
    };

    /**
     * Single page.
     * Included stageMarquee and helpersIcon color.
     */
    initMarquee = () => {
        this.defaultInit(() => {
            const {current_name} = this.props;
            AllTap.$stageMarquee({current_name: current_name}).mainMarquee();
        });
    };

    /**
     * Single page.
     * Included stage360 and helpersIcon color.
     */
    init360 = () => {
        this.defaultInit(() => {
            const {current_name} = this.props;
            AllTap.$stage360({current_name: current_name}).main360();
        });
    };

    /**
     * REVIEW
     */
    initVideo = () => {
        this.defaultInit(() => {
            const {
                btn_video01,
                btn_video02,
                btn_video03,
                btn_video04,
                btn_video05,
                btn_video06
            } = this.getFrame();

            const execute = (event, options) => {
                let occ_button = this.getObject(options, 'occ_button');
                this.openVideo(occ_button, options);
            };

            this.setHandleMouseDown(btn_video01, execute, {
                occ_button: btn_video01,
                name: 'video-01',
                uri: 'doctor.mp4'
            });

            this.setHandleMouseDown(btn_video02, execute, {
                occ_button: btn_video02,
                name: 'video-02',
                uri: 'example.mp4'
            });

            this.setHandleMouseDown(btn_video03, execute, {
                occ_button: btn_video03,
                name: 'video-03',
                uri: 'vr-boy.mp4'
            });

            this.setHandleMouseDown(btn_video04, execute, {
                occ_button: btn_video04,
                name: 'video-04',
                uri: 'vr-girl.mp4'
            });

            this.setHandleMouseDown(btn_video05, execute, {
                occ_button: btn_video05,
                name: 'video-05',
                uri: 'doctor.mp4'
            });

            this.setHandleMouseDown(btn_video06, execute, {
                occ_button: btn_video06,
                name: 'video-06',
                uri: 'example.mp4'
            });
        });
    };

    /**
     * REVIEW
     */
    initTour = () => {
        this.defaultInit(() => {
            const {
                btn_video01,
                btn_video02
            } = this.getFrame();

            const execute = (event, options) => {
                let occ_button = this.getObject(options, 'occ_button');
                this.openTour(occ_button, options);
            };

            this.setHandleMouseDown(btn_video01, execute, {
                occ_button: btn_video01,
                name: 'video-01',
                uri: 'https://dlightvr.com.br/fibra/florida/36_studio'
            });

            this.setHandleMouseDown(btn_video02, execute, {
                occ_button: btn_video02,
                name: 'video-02',
                uri: 'https://dlightvr.com.br/fibra/florida/33_apto/'
            });
        });
    };

    initImplantationAndOrientation = () => {
        this.defaultPaginateInit(() => {
            const
                _this_current = this.get(),
                {current_name, current_page, color_icon} = this.props,
                {paginate, paginates} = this.getPaginate();

            if (current_page === 'implantacao') {
                AllTap.$stagePin({
                    current_name: current_name,
                    xml: this.verifyField(paginate, 'xml'),
                    content_text: this.verifyField(paginate, 'content_text')
                }).mainPin();

                this.destroyTicker('_handleZoom');
            } else if (current_page === 'orientacao') {
                AllTap.$stageSun({
                    current_name: current_name,
                    current_page: current_page
                }).mainSun();

                this.destroyTicker('_handleZoom');
            } else if (current_page === 'planta') {
                AllTap.$stageZoom({current_name: current_name}).mainZoom();
            }

            for (let property of paginates) {
                this.$helpersIcon.setIcon(_this_current, color_icon, property.frame);
            }

            this.$helpersIcon.disabledAnimate(_this_current)(paginate.frame);
        });
    };

    /**
     * REVIEW
     * Paginate.
     * Included stagePaginate and helpersIcon color.
     */
    initSlide = () => {
        this.defaultPaginateInit(() => {
            const
                _this_current = this.get(),
                {color_icon} = this.props,
                occ_pseudo_frame = this.verifyField(_this_current, 'occ_pseudo_frame01'),
                btn_frame = this.verifyField(_this_current, 'btn_frame01');

            this.$helpersIcon.disabledAnimate(_this_current)(1, 'frame');

            this.$helpersIcon.setIcon(_this_current, color_icon, 1);

            this.$helpersIcon.setIcon(_this_current, color_icon, 2);

            this.$helpersIcon.setIcon(_this_current, color_icon, 3);

            occ_pseudo_frame && (occ_pseudo_frame.visible = true);

            btn_frame && (btn_frame.visible = false);
        }, true);
    };

    // initSector = () => {
    //     this.defaultInit(() => {
    //         const {occ_line, btn_01, btn_02, btn_03, btn_04, btn_06} = this.getFrame();
    //
    //         this.setHandleMouseDown(btn_01, () => {
    //             this.gotoAndStopFrame(occ_line, 1);
    //             occ_line.occ_01.gotoAndPlay('start');
    //         });
    //
    //         this.setHandleMouseDown(btn_02, () => {
    //             this.gotoAndStopFrame(occ_line, 2);
    //             occ_line.occ_02.gotoAndPlay('start');
    //         });
    //
    //         this.setHandleMouseDown(btn_03, () => {
    //             this.gotoAndStopFrame(occ_line, 3);
    //             occ_line.occ_03.gotoAndPlay('start');
    //         });
    //
    //         this.setHandleMouseDown(btn_04, () => {
    //             this.gotoAndStopFrame(occ_line, 4);
    //             occ_line.occ_04.gotoAndPlay('start');
    //         });
    //
    //         this.setHandleMouseDown(btn_06, () => {
    //             this.gotoAndStopFrame(occ_line, 6);
    //             occ_line.occ_06.gotoAndPlay('start');
    //         });
    //     });
    // };

    initSectorPaginate = () => {
        this.defaultPaginateInit(() => {
            const {occ_line, btn_01, btn_02, btn_03, btn_04, btn_05, btn_06, btn_07} = this.getFrame();

            this.setHandleMouseDown(btn_01, () => {
                this.gotoAndStopFrame(occ_line, 1);
                occ_line.occ_01.gotoAndPlay('start');
            });

            this.setHandleMouseDown(btn_02, () => {
                this.gotoAndStopFrame(occ_line, 2);
                occ_line.occ_02.gotoAndPlay('start');
            });

            this.setHandleMouseDown(btn_03, () => {
                this.gotoAndStopFrame(occ_line, 3);
                occ_line.occ_03.gotoAndPlay('start');
            });

            this.setHandleMouseDown(btn_04, () => {
                this.gotoAndStopFrame(occ_line, 4);
                occ_line.occ_04.gotoAndPlay('start');
            });

            // this.setHandleMouseDown(btn_05, () => {
            //     this.gotoAndStopFrame(occ_line, 5);
            //     occ_line.occ_05.gotoAndPlay('start');
            // });

            this.setHandleMouseDown(btn_06, () => {
                this.gotoAndStopFrame(occ_line, 6);
                occ_line.occ_06.gotoAndPlay('start');
            });

            // this.setHandleMouseDown(btn_07, () => {
            //     this.gotoAndStopFrame(occ_line, 7);
            //     occ_line.occ_07.gotoAndPlay('start');
            // });
        });
    };

    initExternal = () => {
        this.defaultPaginateInit(() => {
            const
                _this_current = this.get(),
                {color_icon} = this.props,
                occ_pseudo_frame = this.verifyField(_this_current, 'occ_pseudo_frame01'),
                btn_frame = this.verifyField(_this_current, 'btn_frame01'),
                children = this.verifyField(_this_current, 'occ_frame_03.occ_external.children');

            this.$helpersIcon.disabledAnimate(_this_current)(1, 'frame');

            this.$helpersIcon.setIcon(_this_current, color_icon, 1);

            this.$helpersIcon.setIcon(_this_current, color_icon, 2);

            this.$helpersIcon.setIcon(_this_current, color_icon, 3);

            occ_pseudo_frame && (occ_pseudo_frame.visible = true);

            btn_frame && (btn_frame.visible = false);

            let external = {
                '01': {
                    name: 'ALLTAP',
                    uri: 'https://www.alltap.com.br'
                },
                '02': {
                    name: 'ANIMATE CSS',
                    uri: 'https://animate.style/'
                },
                '03': {
                    name: 'BOOTSTRAP 5',
                    uri: 'https://getbootstrap.com/docs/5.0/getting-started/introduction'
                },
                '04': {
                    name: 'REACT JS',
                    uri: 'https://pt-br.legacy.reactjs.org'
                },
                '05': {
                    name: 'A-FRAME',
                    uri: 'https://aframe.io'
                },
                '06': {
                    name: 'CREATEJS',
                    uri: 'https://createjs.com'
                },
                '07': {
                    name: 'ADOBE ANIMATE',
                    uri: 'https://www.adobe.com/br/products/animate.html'
                }
            }

            if (this.isArrayIf(children)) {
                for (let property of children) {
                    let
                        name = property.name,
                        number = this.toNumber(name),
                        occ = this.padWithLeadingZeros(number, 2);

                    this.openExternal(property, external[occ]);
                }
            }
        }, true);
    };
}

/**
 *
 * @type {{}}
 */
PageCurrent.propTypes = {
    current_name: PropTypes.string,
    frame: PropTypes.number,
    color_icon: PropTypes.string
};

/**
 *
 * @type {{}}
 */
PageCurrent.defaultProps = {
    current_name: null,
    frame: indexConfig.init.frame,
    color_icon: pageConfig.button.color_icon
};

/**
 *
 * @type {{}}
 * @private
 */
PageCurrent._this = {};

/**
 *
 * @param ClassObject
 * @param className {className: 'className'}
 * @returns {function(*): function({}=): *} pass _this ClassMain (required) and props {} (optional)
 */
export default WithType(PageCurrent, {className: 'PageCurrent'});
